export enum BannerType {
  information = 0,
  warning,
  error,
  confirmation
}

